import { atom, selector, useRecoilState } from "recoil";
import { getCustomerSettings } from "../CustomerSettings";
import { useCallback } from "react";

const layoutState = atom({
  key: 'layoutState',
  default: selector({
    key: 'layoutStateSelector',
    get: () => {
      return getCustomerSettings('layout');
    }
  })
});

export const useLayoutState = () => {
  const [layout, setLayout] = useRecoilState(layoutState);
  const isHorizontal = layout === 'horizontal';
  const isVertical = layout === 'vertical';
  const isMapOnly = layout === 'map-only';
  const isCrossOnly = layout === 'cross-only';

  const changeHorizontal = useCallback(() => {
    setLayout('horizontal');
  }, [setLayout]);

  const changeVertical = useCallback(() => {
    setLayout('vertical');
  }, [setLayout]);

  const changeMapOnly = useCallback(() => {
    setLayout('map-only');
  }, [setLayout]);

  const changeCrossOnly = useCallback(() => {
    setLayout('cross-only');
  }, [setLayout]);

  return {
    layout,
    isHorizontal,
    isVertical,
    isMapOnly,
    isCrossOnly,
    changeHorizontal,
    changeVertical,
    changeMapOnly,
    changeCrossOnly
  }
}